import React, { Fragment } from 'react'
import styled from 'styled-components'
import Helmet from 'react-helmet'

import PostTags from '../components/PostTags/PostTags'
import SocialLinks from '../components/SocialLinks/SocialLinks'
import SEO from '../components/SEO/SEO'
import config from '../../data/SiteConfig'
// @material-ui/core components
import withStyles from '@material-ui/core/styles/withStyles'
// @material-ui/icons
// core components
import Parallax from '../components/Parallax/Parallax.jsx'
import GridContainer from '../components/Grid/GridContainer.jsx'
import GridItem from '../components/Grid/GridItem.jsx'

import blogPostPageStyle from '../assets/jss/material-kit-pro-react/views/blogPostPageStyle.jsx'

class PostTemplate extends React.Component {
  render() {
    const { slug } = this.props.pathContext
    const postNode = this.props.data.markdownRemark
    const post = postNode.frontmatter
    if (!post.id) {
      post.id = slug
    }
    if (!post.category_id) {
      post.category_id = config.postDefaultCategoryID
    }
    const { classes } = this.props
    return (
      <Fragment>
        <Helmet>
          <title>{`${post.title} | ${config.siteTitle}`}</title>
        </Helmet>
        <SEO postPath={slug} postNode={postNode} postSEO />
        <Parallax
          image={post.cover && post.cover.childImageSharp.sizes.src}
          filter="dark"
        >
          <div className={classes.container}>
            <GridContainer justify="center">
              <GridItem md={8} className={classes.textCenter}>
                <h1 className={classes.title}>{post.title}</h1>
                <h5 className={classes.title}>{postNode.fields.date}</h5>
                <div className={classes.subtitle}>
                  <PostTags tags={post.category} />
                </div>
              </GridItem>
            </GridContainer>
          </div>
        </Parallax>
        <PostContainer className={classes.main}>
          <GridContainer justify="center">
            <GridItem xs={12} sm={8} md={8}>
              <div className={classes.container}>
                <div className={classes.section}>
                  <div dangerouslySetInnerHTML={{ __html: postNode.html }} />
                </div>
              </div>
            </GridItem>
          </GridContainer>
          <SocialLinks postPath={slug} postNode={postNode} />
        </PostContainer>
      </Fragment>
    )
  }
}

PostTemplate.defaultProps = {
  noPadding: true,
}

const PostContainer = styled.div`
  padding: ${p => p.theme.col(1.5)};
`

export default withStyles(blogPostPageStyle)(PostTemplate)

/* eslint no-undef: "off" */
export const pageQuery = graphql`
  query BlogPostBySlug($slug: String!) {
    markdownRemark(fields: { slug: { eq: $slug } }) {
      html
      timeToRead
      excerpt
      frontmatter {
        title
        cover {
          childImageSharp {
            sizes(maxWidth: 1920) {
              ...GatsbyImageSharpSizes_withWebp
            }
          }
        }
        date
        category
      }
      fields {
        nextTitle
        nextSlug
        prevTitle
        prevSlug
        slug
        date(formatString: "dddd, MMMM Do YYYY")
      }
    }
  }
`



// WEBPACK FOOTER //
// ./src/templates/post.jsx